import { render, staticRenderFns } from "./costlossManageDetail.vue?vue&type=template&id=e951d546"
import script from "./costlossManageDetail.vue?vue&type=script&lang=js"
export * from "./costlossManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e951d546')) {
      api.createRecord('e951d546', component.options)
    } else {
      api.reload('e951d546', component.options)
    }
    module.hot.accept("./costlossManageDetail.vue?vue&type=template&id=e951d546", function () {
      api.rerender('e951d546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/costloss/costlossManageDetail.vue"
export default component.exports